// Custom: expandable subcategory groups inside list-type facets (e.g. Бижута -> Колие, Обеци)
// Uses event delegation so it keeps working after the facets form re-renders on filter change.
// Runs in the CAPTURE phase and calls stopPropagation so the theme's MenuDrawer close-button
// listener (attached directly to every <button> inside the mobile filter drawer) never sees
// this click - otherwise it mistakes our group toggle for its own "close submenu" button and
// collapses the whole filter panel.
(function () {
  // Groups the user currently has expanded, tracked by their data-group-toggle id. Kept in
  // memory (not the DOM) because Shopify's facet AJAX update (FacetFiltersForm.renderFilters /
  // renderMobileCounts in facets.js) replaces the filter list's innerHTML/outerHTML every time a
  // checkbox is (un)checked, which would otherwise reset every group back to closed and force the
  // shopper to re-expand it before picking a second item from the same group.
  var openGroups = new Set();

  function applyGroupState(toggle) {
    var groupId = toggle.getAttribute('data-group-toggle');
    var isOpen = openGroups.has(groupId);
    toggle.setAttribute('aria-expanded', String(isOpen));
    toggle.classList.toggle('is-open', isOpen);
    document.querySelectorAll('[data-group-child="' + groupId + '"]').forEach(function (item) {
      item.hidden = !isOpen;
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var toggle = event.target.closest('[data-group-toggle]');
      if (!toggle) return;

      event.preventDefault();
      event.stopPropagation();

      var groupId = toggle.getAttribute('data-group-toggle');
      var nowExpanded = !openGroups.has(groupId);

      if (nowExpanded) {
        openGroups.add(groupId);
      } else {
        openGroups.delete(groupId);
      }

      applyGroupState(toggle);
    },
    true
  );

  // Custom: replace the row of individual active-filter pills ("Тип продукт: Колие x",
  // "Тип продукт: Сапунен букет x", ...) with a single plain-language count ("3 избрани
  // филтъра"). The individual pills are hidden via CSS (component-facets.css); this only injects
  // and keeps the count text up to date. The "Премахване на всички" clear-all link is a separate
  // element/class and is left completely alone, so clearing all filters still works normally.
  function updateActiveFacetsSummary(container) {
    if (!container) return;

    var pillLinks = container.querySelectorAll('facet-remove > a.active-facets__button--light');
    var count = pillLinks.length;

    // The desktop sidebar (.active-facets-desktop) wraps its own "Филтър" heading + clear-all
    // link in a dedicated flex row (.active-facets-vertical-filter, justify-content:space-between).
    // Insert the count INSIDE that row (in place of the static heading) instead of prepending it
    // to the outer container, which used to push it onto its own line above that row - a
    // disconnected-looking "1 избран филтър" / "Филтър: Премахване на всички" stack.
    var verticalFilterRow = container.querySelector('.active-facets-vertical-filter');
    var insertTarget = verticalFilterRow || container;

    var summary = container.querySelector('.active-facets__summary-count');
    if (!summary) {
      summary = document.createElement('span');
      summary.className = 'active-facets__summary-count';
      insertTarget.insertBefore(summary, insertTarget.firstChild);
    } else if (summary.parentElement !== insertTarget) {
      insertTarget.insertBefore(summary, insertTarget.firstChild);
    }

    var word = count === 1 ? 'избран филтър' : 'избрани филтъра';
    var newText = count === 0 ? '' : count + ' ' + word;
    var newHidden = count === 0;

    // Guard against no-op writes: MutationObserver watches this same subtree, and an
    // unconditional textContent write (even to an identical value) still fires a childList
    // mutation, which would otherwise re-trigger this function forever.
    if (summary.textContent !== newText) summary.textContent = newText;
    if (summary.hidden !== newHidden) summary.hidden = newHidden;

    // Hide the static "Филтър" heading once we have our own count to show in its place, so the
    // row reads as one label ("1 избран филтър   Премахване на всички") instead of two. Uses an
    // inline style rather than the "hidden" IDL property: the theme's own ".facets__heading
    // {display:block}" rule (an author rule) outranks the UA default "[hidden]{display:none}",
    // so setting .hidden alone silently has no visual effect on this element.
    if (verticalFilterRow) {
      var heading = verticalFilterRow.querySelector('.facets__heading--vertical');
      if (heading) heading.style.display = count > 0 ? 'none' : '';
    }
  }

  function refreshAll() {
    if (openGroups.size > 0) {
      document.querySelectorAll('[data-group-toggle]').forEach(applyGroupState);
    }
    document.querySelectorAll('.active-facets-mobile, .active-facets-desktop').forEach(updateActiveFacetsSummary);
  }

  refreshAll();

  // Whenever the facet list or active-filter pills get swapped out from under us (filter
  // selected -> AJAX re-render), re-apply whichever groups were open and refresh the pill count,
  // so the shopper's place in the list is preserved and the count stays accurate.
  var observer = new MutationObserver(refreshAll);
  observer.observe(document.body, { childList: true, subtree: true });
})();
